import { Bell, User, Users, LayoutDashboard, Film, Users as UsersAdmin, UserCheck, ScrollText, Wrench, ArrowLeft, Settings, } from 'lucide-react';
export const primaryNavItems = [
    { label: 'Parties', to: '/parties', icon: Users, exact: true },
    { label: 'Me', to: '/me', icon: User },
];
export const adminNavItems = [
    { label: 'Dashboard', to: '/admin', icon: LayoutDashboard, exact: true },
    { label: 'Works', to: '/admin/works', icon: Film },
    { label: 'People', to: '/admin/people', icon: UsersAdmin },
    { label: 'Users', to: '/admin/users', icon: UserCheck },
    { label: 'Logs', to: '/admin/logs', icon: ScrollText },
    { label: 'Tool Logs', to: '/admin/tool-logs', icon: Wrench },
    { label: 'Settings', to: '/admin/settings', icon: Settings },
];
export const backToAppItem = {
    label: 'Back to App',
    to: '/parties',
    icon: ArrowLeft,
};
export const notificationsNavItem = {
    label: 'Notifications',
    to: '/notifications',
    icon: Bell,
};
export const bottomNavItems = [
    { label: 'Parties', to: '/parties', icon: Users, exact: true },
    { label: 'Me', to: '/me', icon: User },
];
